import React from 'react';
import Router from './LoadableRouter';


const AppRoot = () => (
  <div style={{'marginLeft': '2%', 'marginRight': '2%'}}><Router /></div>
)

export default AppRoot;



// WEBPACK FOOTER //
// ./src/App.js